/* eslint-disable prettier/prettier */
import { computed } from "vue"
import { useStore } from "vuex"

const penitentiary = () =>{
    const store = useStore()

    const nameDepartments = async () =>{
        // console.log('usePenitentiary')
        const resp = await store.dispatch("penitentiary/loadDepartments")
            return resp
    }

    const nameProvinces = async (department) =>{
        // console.log('usePenitentiary', department)
        const resp = await store.dispatch("penitentiary/loadProvinces", department)
            return resp
    }

    const nameMunicipalities = async (department, province) =>{
        // console.log('usePenitentiary', department, province)
        const data = {
            department,
            province
        }
        const resp = await store.dispatch("penitentiary/loadMunicipalities", data)
            return resp
    }
    
    const penitentiaries = async () => {
        const resp = await store.dispatch("penitentiary/loadPenitentiaries")
        return resp
    }
    
    const createPenitentiary = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("penitentiary/createPenitentiary", data)
        return resp
    }

    const infoPenitentiary = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("penitentiary/infoPenitentiary", data)
        return resp
    }

    const updatePenitentiary = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("penitentiary/updatePenitentiary", data)
        return resp
    }

    const deletePenitentiary = async(data) => {
        // console.log('usePenitentiary delete', data)
        const resp = await store.dispatch("penitentiary/deletePenitentiary", data)
        return resp
    }

    const incrementar = async() => {
        const resp = await store.dispatch("penitentiary/incrementarValor")
        return resp
    }

    const incrementarPor = async(data) => {
        const resp = await store.dispatch("penitentiary/incrementarValorPor", data)
        return resp
    }


    // const nameCourts = async()=> {
    //     const resp =await store.dispatch("filiation/loadNameCourts")
    //         return resp
    // }
    // const typeCourts = async()=> {
    //     const resp =await store.dispatch("filiation/loadTypeCourts")
    //         return resp
    // }
    // const typeCodes = async()=> {
    //     const resp =await store.dispatch("filiation/loadTypeCodes")
    //         return resp
    // }
    // const prisionNames = async()=> {
    //     const resp =await store.dispatch("filiation/loadPrisionNames")
    //         return resp
    // }
    // const crimes = async()=> {
    //     const resp =await store.dispatch("filiation/loadCrimes")
    //         return resp
    // }
    // const saveCourtOrderData = async (data) =>{
    //             const resp = await store.dispatch("filiation/saveCourtOrderData",data)
    //             return resp
    // }
    // const documentType = async()=> {
    //     const resp =await store.dispatch("filiation/loadDocumentTypes")
    //         return resp
    // }
    
    // const searchSegip = async (data) =>{
    //     const resp =await store.dispatch("filiation/dataSegip", data)
    //     console.log(resp)
    //       return resp
    // }
    // const civilStatus = async () =>{
    //     const resp =await store.dispatch("filiation/loadCivilStatus")
    //        return resp
    // }
    // const ethnicIdentification = async () =>{
    //     const resp =await store.dispatch("filiation/loadEthnicIdentification")
    //        return resp
    // }
    // const languages = async () =>{
    //     const resp =await store.dispatch("filiation/loadLanguages")
    //        return resp
    // }
    // const sexual_orientation = async () =>{
    //     const resp =await store.dispatch("filiation/loadSexualOrientation")
    //        return resp
    // }
    // const religions = async () =>{
    //     const resp =await store.dispatch("filiation/loadReligion")
    //        return resp
    // }
    // const professions = async () =>{
    //     const resp =await store.dispatch("filiation/loadProfession")
    //        return resp
    // }
    // const jobs = async () =>{
    //     const resp =await store.dispatch("filiation/loadJob")
    //        return resp
    // }
    // const degreeInstructions = async () =>{
    //     const resp =await store.dispatch("filiation/loadDegreeInstruction")
    //        return resp
    // }
    // const relationships = async () =>{
    //     const resp =await store.dispatch("filiation/loadRelationship")
    //        return resp
    // }
    return{
        nameDepartments,
        nameProvinces,
        nameMunicipalities,
        penitentiaries,
        createPenitentiary,
        infoPenitentiary,
        updatePenitentiary,
        deletePenitentiary,

        incrementar,
        incrementarPor,
        // nameCourts,
        // typeCourts,
        // typeCodes,
        // prisionNames,
        // crimes,
        // saveCourtOrderData,
        // documentType,
        // searchSegip,
        // civilStatus,
        // ethnicIdentification,
        // languages,
        // sexual_orientation,
        // religions,
        // professions,
        // jobs,
        // degreeInstructions,
        // relationships,
        penitentiaryData: computed(()=>store.getters["penitentiary/penitentiaryData"]),
        getContador: computed(()=>store.getters["penitentiary/contador"]),
        getCuadrado: computed(()=>store.getters["penitentiary/cuadrado"]),
        getPenitentiary: computed(()=>store.getters["penitentiary/getPenitentiary"]),
    }
};

export default penitentiary